import { useState } from "react";
import ErrorMessage from "./ErrorMessage";

interface TextareaInputProps {
  label: string;
  name: string;
  rows?: number;
  placeholder?: string;
  value?: string;
  onChange?: (e: any) => void;
  errors?: Record<string, string>;
  errorMessage?: string;
  isReadOnly?: boolean;
}

function TextareaInput({
  label,
  name,
  rows = 3,
  placeholder,
  value = "",
  onChange,
  errors = {},
  errorMessage = "",
  isReadOnly = false,
}: TextareaInputProps) {
  //   const [value, setValue] = useState(value);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange?.(e);
  };

  return (
    <div className="mb-4 form-dark-text">
      <label className="form-label " htmlFor={name}>
        {label}
      </label>
      <textarea
        id={name}
        name={name}
        className="form-control mt-2"
        rows={rows}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        readOnly={isReadOnly}
      />
      {errorMessage?.length > 0 && (
        <div className="pt-1">
          <ErrorMessage message={errorMessage} />
        </div>
      )}
      {errors[name]?.length > 0 && (
        <p className="flex-1 text-danger mt-1 ps-1 fs-12 ">{errors[name]}</p>
      )}
    </div>
  );
}

export default TextareaInput;
